import $ from 'jquery'
import validate from 'jquery-validation'

var Contact = function() {

	var initFormValidations = function () {
		var contactForm = $('.create-schedule-form');
		
		contactForm.validate({
			ignore: [],
			errorClass: 'invalid-feedback animated fadeInDown',
			errorElement: 'div',
			errorPlacement: function(error, e)
            {
                $(e).parents('.form-floating').append(error);
            },
            highlight: function(e) {
                $(e).closest('.form-floating').removeClass('is-invalid').addClass('is-invalid');
            },
            unhighlight: function (e) {
                $(e).closest('.form-floating').removeClass('is-invalid').removeClass('is-invalid');
            },
            success: function(e) {
                $(e).closest('.form-floating').removeClass('is-invalid');
                $(e).remove();
            },
			rules: {
				'fname': {
					required: true,
				},
				'lname': {
					required: true,
				},
				'email': {
					required: true,
					email: true,
                		remote: {
                    		url: '/scheduledemo/checkEmail',
                    		type: "post",
                    		headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
                 		}
				},
				'company': {
					required: true,
				},
				'title': {
					required: true,
				},
				'industry': {
					required: true,
				},
				'product_interest[]':{
            		required: true,
            		minlength: 1
          		},
			},
			messages: {
				'fname': {
					required: "Enter your first name."
				},
				'lname': {
					required: "Enter your last name."
				},
				'email': {
					required: "Enter your email address.",
					email: "Please enter valid email address.",
					remote: "This email address has already been used. If you would like to reschedule a demo, please email us at support@prolius.com"
				},
				'company': {
					required: "Enter your company name."
				},
				'title': {
					required: "Enter your job title."
				},
				'industry': {
					required: "Enter your industry name."
				},
				'product_interest[]': "You must check at least 1 box.",
			},
			submitHandler: function(form, event) {
				event.preventDefault();

				$.when(refreshReCaptchaV3('demo_captcha_id', 'demo_captcha_action')).then(function() {
                    
					if (window._mfq) {
                        window._mfq.push(['formSubmitSuccess', form]);
                    }

					form.submit();

				});
			}
		});
	};

	return{
		init: function () {
			initFormValidations();
		}
	}
}();
jQuery(function () {
	Contact.init();
});

$(document).ready(function () {
	const params = new URLSearchParams(window.location.search);
	if (params.get('submitted') === 'yes') {
		setTimeout(function() {
			window.location.href = '/';
		}, 10000);
	}
});